import {
  faXmark as CancelIcon,
  faPen as EditIcon,
  faFloppyDisk as SaveIcon
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
  Stack,
  Typography
} from '@mui/material';
import { useState } from 'react';

import CheckPermissions from '@/components/CheckPermissions';
import LargeCard from '@/components/LargeCard';
import { PERMISSIONS } from '@/constants/auth.constants';
import useDraftState from '@/hooks/useDraftState';
import useStyles from '@/pages/Administration/AdministrationGeneral/AdministrationGeneral.styles';

import type { MFAProps } from './MultifactorAuthentication.types';

const MultifactorAuthentication = (props: MFAProps) => {
  const { classes } = useStyles();
  const { handleSave, orgInfo } = props;
  const [editing, isEditing] = useState<boolean>(false);
  const [updatedOrgInfo, updateDraft, resetDraft] = useDraftState(orgInfo);

  const handleMFAChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateDraft({ multifactor: event.target.checked });
  };

  return (
    <LargeCard
      title="Multifactor Authentication"
      rightContent={
        <CheckPermissions permissions={PERMISSIONS.ADMIN_UPDATE}>
          {editing ? (
            <Stack direction="row">
              <IconButton
                onClick={() => {
                  isEditing(!editing);
                  handleSave(updatedOrgInfo);
                }}
              >
                <FontAwesomeIcon size="xs" icon={SaveIcon} />
              </IconButton>
              <IconButton
                onClick={() => {
                  isEditing(!editing);
                  resetDraft();
                }}
              >
                <FontAwesomeIcon size="xs" icon={CancelIcon} />
              </IconButton>
            </Stack>
          ) : (
            <IconButton onClick={() => isEditing(!editing)}>
              <FontAwesomeIcon size="xs" icon={EditIcon} />
            </IconButton>
          )}
        </CheckPermissions>
      }
    >
      <Typography className={classes.subText} variant="body1">
        Changes to this setting apply to all members of the organization. This
        will require Google Authenticator to be used by all members of the
        organization to log in.
      </Typography>
      <FormGroup sx={{ pt: 1 }}>
        <FormControlLabel
          control={
            <Checkbox
              disabled={!editing}
              checked={updatedOrgInfo.multifactor}
              onChange={handleMFAChange}
            />
          }
          label="Enable Multifactor Authentication"
        />
      </FormGroup>
    </LargeCard>
  );
};

export default MultifactorAuthentication;
